// import lz from 'lz-string'
import Image from 'next/image'
// import React, { useMemo, useState, useContext } from 'react'
import React, { useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import SvgPerson from '#/assets/images/icons/person_marker.svg'
// import AuthLock from '#/components/AuthLock'
import Link from '#/components/Link'
// import api from '#/configs/api'
// import { accessToken, mapStyleId } from '#/configs/mapbox'
// import { BREAK_SM } from '#/consts'
import { hasRole } from '#/consts/plan'
import ViewModeContext from '#/contexts/ViewMode'
// import { logEvent } from '#/services/analytics'
// import { initialState as initPreferences } from '#/store/reducers/preferences'
import { currentRoleWithShared } from '#/store/selectors/user'
import { CardWithDetailProps } from '../../types'
import { Section } from '../common'

type ItemProps = {
  image: string
  label: string
  link?: string
  centerIcon?: React.ReactNode
  description: string
  onClick?: (ev: React.MouseEvent) => void
  authLock?: React.ReactElement
  linkEnabled?: boolean
}

const Item: React.FC<ItemProps> = ({
  image,
  label,
  description,
  link,
  authLock,
  centerIcon,
  onClick,
  linkEnabled = true
}) => {
  const [imgLoaded, setImgLoaded] = useState(false)
  const onLoaded = () => {
    setImgLoaded(true)
  }
  const viewMode = useContext(ViewModeContext)
  const userRole = useSelector(currentRoleWithShared)
  const hasPermission =
    !authLock || hasRole(userRole, authLock.props.requireRole as TopHap.UserRole)

  const ele = (
    <li
      className='inline-flex w-56 cursor-pointer snap-center flex-col whitespace-normal'
      onClick={onClick}
    >
      <div className='relative h-36 w-full overflow-hidden rounded-xl shadow-md'>
        {authLock}
        {(!imgLoaded && viewMode === 'WEB_DETAIL_PAGE') && (
          <div className='absolute h-full w-full overflow-hidden rounded-xl'>
            <svg
              fill='none'
              height='144'
              viewBox='0 0 224 144'
              width='224'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect fill='#F2F2F2' height='144' width='224' />
            </svg>
          </div>
        )}
        <Image
          alt={label}
          className='object-fill'
          height={144}
          src={image}
          width={224}
          onLoadingComplete={() => onLoaded()}
        />

        <div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'>
          {centerIcon}
        </div>
      </div>
      <div className='px-3'>
        <h3 className='mt-4 text-sm font-semibold text-gray-900'>{label}</h3>
        <p className='mt-1 text-xs text-gray-500'>{description}</p>
      </div>
    </li>
  )

  return link && hasPermission && linkEnabled ? (
    <Link href={link}>{ele}</Link>
  ) : (
    ele
  )
}

type Props = CardWithDetailProps & {
  // ui: TopHap.UIState
  isBot?: boolean
  // appView: boolean
}

const LocationInformation: React.FC<Props> = ({
  property,
  // ui,
  onDetail,
  // appView,
  isBot = false
}) => {
  // const baseUrl = `${api.previewBaseUrl}/map/224/144`

  // const urls = useMemo(() => {
  //   const m = {
  //     c: property.location,
  //     z: 16,
  //     p: 0,
  //     b: 0
  //   }
  //   const common = {
  //     l: [property.id],
  //     sv: ui.viewport.width >= BREAK_SM,
  //     sm: ui.siderMode,
  //     sp: ui.sider.properties,
  //     le: ui.isLegendExpanded
  //   }

  //   return {
  //     map: lz.compressToEncodedURIComponent(
  //       JSON.stringify({
  //         ...common,
  //         m,
  //         p: {
  //           ...initPreferences.map.properties,
  //           enabled: false
  //         },
  //         d: {
  //           ...initPreferences.map.descriptive,
  //           enabled: false
  //         }
  //       })
  //     ),
  //     analytics: lz.compressToEncodedURIComponent(
  //       JSON.stringify({
  //         ...common,
  //         m,
  //         p: {
  //           ...initPreferences.map.properties,
  //           enabled: true
  //         }
  //       })
  //     ),
  //     school: lz.compressToEncodedURIComponent(
  //       JSON.stringify({
  //         ...common,
  //         m: {
  //           ...m,
  //           z: 12
  //         },
  //         p: {
  //           ...initPreferences.map.properties,
  //           enabled: false
  //         },
  //         d: {
  //           ...initPreferences.map.descriptive,
  //           enabled: false
  //         },
  //         z: { school: true }
  //       })
  //     )
  //   }
  // }, [property.id, ui])

  // function logClick(card_name: string) {
  //   logEvent('select_content', {
  //     content_type: 'property_detail',
  //     item_id: 'click_card',
  //     value: card_name,
  //     property_id: property.id,
  //     address: property.displayAddress
  //   })
  // }

  if (isBot) return null
  return (
    <Section
      description={(
        <>Views of <span>{property.displayAddress}</span>.</>
      )}
      id='location'
      title='Location Information'
    >
      <Item
        centerIcon={<SvgPerson className='h-7 w-7 text-primary' />}
        description='Take a virtual walk around the neighborhood.'
        // image={`https://api.mapbox.com/styles/v1/tophapinc/${mapStyleId.color}/static/${property.location[0]},${property.location[1]},16,0,0/224x144@2x?access_token=${accessToken}`}
        image={`https://static.tiles.tophap.com/street/static/${property.location[0]},${property.location[1]},16/224x144.png`}
        label='Street View'
        onClick={() => onDetail && onDetail('StreetView')}
      />
    </Section>
  )

  // return (
  //   <Section
  //     description={(
  //       <>Various map views of <span>{property.displayAddress}</span>.</>
  //     )}
  //     id='location'
  //     title='Location Information'
  //   >
  //     {!isBot && (
  //       <Item
  //         centerIcon={<SvgPerson className='h-7 w-7 text-primary' />}
  //         description='Take a virtual walk around the neighborhood.'
  //         // image={`https://api.mapbox.com/styles/v1/tophapinc/${mapStyleId.color}/static/${property.location[0]},${property.location[1]},16,0,0/224x144@2x?access_token=${accessToken}`}
  //         image={`https://static.tiles.tophap.com/street/static/${property.location[0]},${property.location[1]},16/224x144.png`}
  //         label='Street View'
  //         onClick={() => onDetail && onDetail('StreetView')}
  //       />
  //     )}
  //     <Item
  //       authLock={(
  //         <AuthLock
  //           event='location_information/analytics_map'
  //           onlyIcon
  //           requireRole='basic'
  //         />
  //       )}
  //       description='Explore different analytics layers.'
  //       image={`${baseUrl}/${urls.analytics}`}
  //       label='Analytics Map'
  //       link={`/map/${urls.analytics}`}
  //       linkEnabled={!appView}
  //       onClick={() => logClick('AnalyticsMap')}
  //     />
  //     {!isBot && (
  //       <Item
  //         description={`Explore the area around ${property.displayAddress}`}
  //         // image={`https://api.mapbox.com/styles/v1/tophapinc/${mapStyleId.light}/static/${property.location[0]},${property.location[1]},16,0,0/224x144@2x?access_token=${accessToken}`}
  //         image={`https://static.tiles.tophap.com/street/static/${property.location[0]},${property.location[1]},16/224x144.png`}
  //         label='Map'
  //         link={`/map/${urls.map}`}
  //         linkEnabled={!appView}
  //         onClick={() => logClick('Map')}
  //       />
  //     )}
  //   </Section>
  // )
}

export default LocationInformation
